<template>
  <div>
    <v-row dense no-gutters class="mt-10">
      <v-col>
        <p class="process-repair-tab-section-title">{{$t('pages.repair.packageDetails')}}</p>
        <p class="process-repair-tab-section-subtitle">{{$t('pages.repair.addPackageInfo')}}</p>
      </v-col>
      <v-col 
      class="d-flex justify-center"
      :cols="model.length === 0 ? 3 : 4">
        <p class="process-repair-tab-section-subtitle mt-13 ml-16">{{$t('headers.addRemovePackage')}}</p>
      </v-col>
    </v-row>
    <v-row 
    v-for="(p, i) in model" 
    :key="i + 200"
    dense >
      <v-col cols="6">
        <text-field-dimensions 
        :label="$t('textFields.dimensions')" 
        v-model="p.dimensions" 
        class="mr-4"
        :disabled="disabled"
        required/>
      </v-col>
      <v-col cols="4">
        <text-field-number 
        :label="$t('textFields.weight')" 
        v-model="p.weight" 
        class="ml-4"
        double
        :disabled="disabled"
        required/>
      </v-col>
      <v-col cols="2" class="d-flex jusitfy-center align-center">
        <primary-btn 
        @click="removePackage(i)"
        label="-"
        :disabled="disabled"
        color="#ff3547"
        :width="70"
        :height="40"/>
      </v-col>
    </v-row>
    <v-row
    v-if="!disabled && model.length < max"
    dense
    justify="end">
      <v-col cols="2" class="d-flex jusitfy-center align-center">
        <primary-btn 
        @click="addPackage"
        label="+"
        color="#61c461"
        :disabled="disabled"
        :width="70"
        :height="40"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextFieldDimensions from '@/components/text-fields/TextFieldDimensions'
import TextFieldNumber from '@/components/text-fields/TextFieldNumber'
import PrimaryBtn from '@/components/btns/PrimaryBtn'
export default {
  components: {
    TextFieldDimensions,
    TextFieldNumber,
    PrimaryBtn
  },
  props: {
    value: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 5
    },
    setDefaultRow: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "value",
    event: "valueChanged"
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit("valueChanged", v)
      }
    }
  },
  methods: {
    addPackage() {
      this.model.push({
        dimensions: '',
        weight: ''
      })

      setTimeout(() => {
        window.scrollTo({
          top: document.body.clientHeight,
          left: 0,
          behavior: 'smooth'
        })
      }, 50)
    },
    removePackage(i) {
      this.model.splice(i, 1)
    }
  },
  mounted() {
    if (this.model.length === 0 && this.setDefaultRow) this.addPackage()
  }
}
</script>

<style>

</style>